import { CommonModule } from '@angular/common';
import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

@Component({
  standalone: true,
  selector: 'rt-add-line',
  templateUrl: 'add-line.component.html',
  styleUrls: ['./add-line.component.less'],
  imports: [IconComponent, CommonModule],
})
export class AddLineComponent {
  @ContentChild(TemplateRef, { static: true })
  public set onTemplateRef(templateRef: TemplateRef<any>) {
    this.iconTemplate = templateRef;
  }

  @Input() public disabled: boolean;
  public iconTemplate: TemplateRef<any>;
}
